<template></template>

<script>
import { PAGES } from 'constants/url';
import RedirectLogged from 'components/mixins/redirect-logged';

export default {
  name: 'page-professional-logout',
  mixins: [
    RedirectLogged,
  ],
  mounted() {
    this.$auth.logout({
      success() {
        this.$nextTick(() => {
          this.redirectLogout(PAGES.PROFESSIONAL.LOGIN);
        });
      },
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/public/logout/page-professional-logout.vue